import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import React from 'react';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { Box, Typography } from '@mui/material';
import { RowModeIds } from '../../../builderPackage/components/editableDataGrid/editableDataGrid.entity';
import { MuiStack } from '../../../components';
import { systemColor } from '../../../theme/systemColor';
var LabourDetails = function (props) {
    var _value$name;
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'Labours' : _a;
    var currValue = (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.filter(function (item) { return item.PostingTypeName === (value === null || value === void 0 ? void 0 : value.SelectedButton); });
    var LabourColumns = [{
            field: 'ChildName',
            headerName: 'Labour name & code',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row, _params$row2;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                        color: systemColor.lightGrey,
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.ChildCode));
                }
            }
        }, {
            field: 'ServiceTypeName',
            headerName: 'Service type',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'Rate',
            headerName: 'Rate (₹)',
            width: 100,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'Quantity',
            headerName: 'Qty ',
            width: 100,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number'
        }, {
            type: 'number',
            field: 'DiscountPercentage',
            headerName: 'Discount rate (%)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            editable: false
        }, {
            type: 'number',
            field: 'DiscountAmount',
            headerName: 'Discount amount (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueSetter: function (value, row) {
                var totalAmount = (row === null || row === void 0 ? void 0 : row.Rate) * (row === null || row === void 0 ? void 0 : row.RequestedQuantity);
                var discountAmount = totalAmount / 100 * row.DiscountPercentage;
                return _objectSpread(_objectSpread({}, row), {}, {
                    DiscountAmount: discountAmount
                });
            },
            valueGetter: function (value, row) {
                var totalAmount = (row === null || row === void 0 ? void 0 : row.Rate) * (row === null || row === void 0 ? void 0 : row.RequestedQuantity);
                var discountAmount = totalAmount / 100 * (row === null || row === void 0 ? void 0 : row.DiscountPercentage);
                return discountAmount;
            }
        }, {
            type: 'number',
            field: 'TaxableAmount',
            headerName: 'Taxable amount (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'CGSTPercentage',
            headerName: 'CGST (%)',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'CGSTAmount',
            headerName: 'CGST (₹)',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'SGST_UTGST_Percentage',
            headerName: 'SGST (%)',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'SGST_UTGST_Amount',
            headerName: 'SGST (₹)',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'IGSTPercentage',
            headerName: 'IGST (%)',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'IGSTAmount',
            headerName: 'IGST (₹)',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'TotalAmount',
            headerName: "Amount (\u20B9)",
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number'
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Labour details",
        isCollapsible: true,
        columns: LabourColumns,
        getToolbarActions: function () { return []; },
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    left: ['__check__', 'LabourName']
                },
                aggregation: {
                    model: {
                        Quantity: 'sum',
                        TaxableAmount: 'sum',
                        DiscountAmount: 'sum',
                        CGSTAmount: 'sum',
                        TotalAmount: 'sum'
                    }
                }
            }
        },
        rows: currValue || [{
                id: '01',
                ChildName: 'My Name',
                UnitOfMeasurementName: '*Purchase*',
                ServiceTypeName: '*PaidPeriodService*',
                EligibleForReturn: 'Not eligible',
                Quantity: '120',
                PendingQty: '100',
                ReturnQuantity: '120',
                Rate: '8',
                DiscountPercentage: '12',
                DiscountAmount: '12',
                TaxableAmount: '100',
                CGSTPercentage: '10%',
                ReturnAmount: '809999'
            }, {
                id: '02',
                ChildName: 'My Name',
                UnitOfMeasurementName: '*Purchase*',
                ServiceTypeName: '*PaidPeriodService*',
                EligibleForReturn: 'Not eligible',
                Quantity: '120',
                PendingQty: '100',
                ReturnQuantity: '120',
                Rate: '8',
                DiscountPercentage: '12',
                DiscountAmount: '12',
                TaxableAmount: '100',
                CGSTPercentage: '10%',
                ReturnAmount: '809999'
            }],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    })));
};
export default LabourDetails;
